import { useState } from 'react'
import { AssaySDK } from '@diwata-labs/assay-sdk'
import { useAuth } from '@/store/auth'

type CaptureState = 'idle' | 'capturing' | 'success' | 'error'

export function CaptureButton() {
  const { assayUrl, assayApiKey, keeper } = useAuth()
  const [state, setState] = useState<CaptureState>('idle')

  if (!assayApiKey.trim()) return null

  async function capture() {
    if (state === 'capturing') return
    setState('capturing')
    try {
      const sdk = new AssaySDK({ apiKey: assayApiKey, endpoint: assayUrl })
      await sdk.capture({
        comment: 'Conclave keeper capture',
        verificationId: keeper?.id || undefined,
      })
      setState('success')
      setTimeout(() => setState('idle'), 2500)
    } catch {
      setState('error')
      setTimeout(() => setState('idle'), 3000)
    }
  }

  const label =
    state === 'capturing' ? '…' :
    state === 'success'   ? '✓' :
    state === 'error'     ? '✕' : '⊙'

  const color =
    state === 'success' ? 'var(--ae-color-feedback-success)' :
    state === 'error'   ? 'var(--ae-color-feedback-error)'   : undefined

  return (
    <button
      onClick={capture}
      title="Capture screenshot via Assay"
      style={{
        background: 'none',
        border: 'none',
        cursor: state === 'capturing' ? 'default' : 'pointer',
        fontSize: 15,
        color: color ?? 'var(--ae-color-text-muted)',
        padding: '4px 6px',
        borderRadius: 4,
        lineHeight: 1,
      }}
    >
      {label}
    </button>
  )
}
